import { UI_ORDER_TYPES } from '@velocity-exchange/common';
import { DriftStore } from '../useDriftStore';

export const getOrderToastMessage = ({
	orderType,
	editingOrder,
	numOrders,
}: {
	orderType: DriftStore['tradeForm']['orderType'];
	editingOrder?: boolean;
	numOrders?: number;
}) => {
	return `${UI_ORDER_TYPES[orderType].label} order${
		numOrders && numOrders > 1 ? 's' : ''
	} ${editingOrder ? 'edited' : 'placed'}.`;
};
